export { default as EN } from "./en.json";
export const SIMULATOR_NAMESPACE = "simulator";
